import React from 'react'
import PropTypes from 'prop-types'
import { at } from 'lodash'
import { useField } from 'formik'
import { FormControl, Select, MenuItem, FormHelperText, ListItemText } from '@material-ui/core'

interface MultipleSelectFieldProps {
    name: string
    data: any
    className: string
    fullWidth: boolean
    multiple: boolean
    label?: string
}

function MultipleSelectField(props: MultipleSelectFieldProps) {
    const ITEM_HEIGHT = 48
    const ITEM_PADDING_TOP = 8
    const MenuProps = {
        PaperProps: {
            style: {
                maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
                width: 250,
            },
        },
    }

    const { label, data, ...rest } = props
    const [field, meta] = useField(props)
    const { value: selectedValue } = field
    const [touched, error] = at(meta, 'touched', 'error')
    const isError = touched && error && true
    function _renderHelperText() {
        if (isError) {
            return <FormHelperText>{error}</FormHelperText>
        }
    }

    // const handleChange = (event) => {
    //     const {
    //         target: { value },
    //     } = event
    // }

    interface Item {
        label: string
        value: string
    }

    return (
        <FormControl {...rest} error={isError} size="small">
            <Select
                multiple
                {...field}
                value={selectedValue ? selectedValue : []}
                renderValue={(selected) => (selected as []).join(', ')}
                variant="outlined"
                MenuProps={MenuProps}
            >
                {data.map((item: Item, index: number) => (
                    <MenuItem key={index} value={item.value}>
                        <ListItemText primary={item.label} />
                    </MenuItem>
                ))}
            </Select>
            {_renderHelperText()}
        </FormControl>
    )
}

MultipleSelectField.defaultProps = {
    data: [],
}

MultipleSelectField.propTypes = {
    data: PropTypes.array.isRequired,
}

export default MultipleSelectField
